export const returnPopperPosition = (id: string) => {
  const popper: any = document.getElementsByClassName(id);
  if (popper.length > 0) {
    for (let i = 0; i < popper.length; i++) {
      popper[i].style.setProperty('position', 'absolute');
    }
  }
}